import { z } from 'zod';

import { languageEnumValidator } from '../../validators';
import { ExampleSchema } from '../words';

export const CommonMistakeSchema = z.object({
  correction: z.string().min(1, 'Correction cannot be empty'),
  explanation: z.string().min(1, 'Explanation cannot be empty'),
  mistake: z.string().min(1, 'Mistake cannot be empty'),
});

export const WordComparisonDetailsSchema = z.object({
  commonMistakes: z.array(CommonMistakeSchema),
  examples: z.array(ExampleSchema),
  grammar: z.string().min(1, 'Grammar cannot be empty'),
  translation: z.string().min(1, 'Translation cannot be empty'),
  type: z.string().min(1, 'Type cannot be empty'),
  usage: z.string().min(1, 'Usage cannot be empty'),
});

export const LanguageSpecificComparisonSchema = z.record(
  z.string(),
  WordComparisonDetailsSchema,
);

export const DifferenceDetailsSchema = z.record(z.string(), z.string());

export const LanguageSpecificDifferenceSchema = z.record(
  z.string(),
  DifferenceDetailsSchema,
);

export const CompareWordsResponseSchema = z.object({
  difference: LanguageSpecificDifferenceSchema,
  languages: z.array(languageEnumValidator),
  wordDetails: z.record(z.string(), LanguageSpecificComparisonSchema),
});

export type ICommonMistakeDto = z.infer<typeof CommonMistakeSchema>;
export type IWordComparisonDetailsDto = z.infer<
  typeof WordComparisonDetailsSchema
>;
export type ILanguageSpecificComparisonDto = z.infer<
  typeof LanguageSpecificComparisonSchema
>;
export type IDifferenceDetailsDto = z.infer<typeof DifferenceDetailsSchema>;
export type ILanguageSpecificDifferenceDto = z.infer<
  typeof LanguageSpecificDifferenceSchema
>;
export type ICompareWordsResponseDto = z.infer<
  typeof CompareWordsResponseSchema
>;
